import { Field, FormSpy,useForm } from "react-final-form";
import { Label } from "../../../shared/components/form/Layout";
import DateInput from "../../../shared/components/form/DateInput";
import Input from "../../../shared/components/form/Input";
import StopSelect from "../../../booking/components/form/StopSelect";
import FieldContainer from "../../../shared/containers/form/FieldContainer";
import ErrorContainer from "../../../shared/containers/form/ErrorContainer";
import { useTranslation } from "react-i18next";
import { selectArrival, selectDeparture } from "../../../../data/booking/actions/map";
import { useDispatch, useSelector } from "react-redux";
import Divider from "../../../shared/components/Divider";
import SlideInAnimation from "../../../shared/components/SlideInAnimation";
import WithStage from "../../../shared/components/form/WithStage";
import moment from 'moment';

import {
    MapPinIcon,
    CalendarIcon,
} from "@heroicons/react/20/solid";

const ItemFormFields = ({ routeId }) => {
    const form = useForm()
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isEditing = useSelector((state) => state.booking.booking.editingService);

    return (
        <WithStage form={form} isEditing={isEditing}>
            {({updateStage, getFieldStage, stage })=> (<>
                <FormSpy
                    subscription={{ values: true }}
                    onChange={(values) => updateStage(values.values)}
                />
                <Divider className={"my-8"}>{t("booking.supported")}</Divider>
                <div className="space-y-8 px-4 lg:px-16">
                    <FieldContainer name="collectionDate">
                        <Label Icon={CalendarIcon} htmlFor="date">
                            {t("booking.supported.date")}
                        </Label>
                        <div className={"max-w-[13rem]"}>
                            <Field
                                id="collectionDate"
                                name="collectionDate"
                                placeholder="jj/mm/aaaa"
                                component={DateInput}
                                disabledAfter={moment().add(1, 'days').toDate()}
                            />
                        </div>
                        <ErrorContainer name="collectionDate" />
                    </FieldContainer>

                    <SlideInAnimation show={stage >= getFieldStage("collectionDate")}>
                        <FieldContainer name="collectionPlace">
                            <Label htmlFor="from" Icon={MapPinIcon}>
                                {t("booking.supported.place")}
                            </Label>
                            <Field
                                id="collectionPlace"
                                name="collectionPlace"
                                routeId={routeId}
                                purpose="lodging"
                                component={StopSelect}
                                onChange={(value) => {
                                    dispatch(selectDeparture(value?.firstInput?.step));
                                }}
                            />
                            <ErrorContainer name="collectionPlace" />
                        </FieldContainer>
                    </SlideInAnimation>
                </div>

                <SlideInAnimation show={stage >= getFieldStage("collectionPlace")}>
                    <Divider>{t("booking.deposits")}</Divider>
                    <div className="space-y-8 px-4 lg:px-16">
                        <FieldContainer name="depositDate">
                            <Label Icon={CalendarIcon} htmlFor="depositDate">
                                {t("booking.deposits.date")}
                            </Label>
                            <div className={"max-w-[13rem]"}>
                                <Field
                                    id="depositDate"
                                    name="depositDate"
                                    placeholder="jj/mm/aaaa"
                                    component={DateInput}
                                />
                            </div>
                            <ErrorContainer name="depositDate" />
                        </FieldContainer>

                        <SlideInAnimation show={stage >= getFieldStage("depositDate")}>
                            <FieldContainer name="depositPlace">
                                <Label Icon={MapPinIcon} htmlFor="depositPlace">
                                    {t("booking.deposits.place")}
                                </Label>
                                <Field
                                    id="depositPlace"
                                    name="depositPlace"
                                    routeId={routeId}
                                    purpose="lodging"
                                    component={StopSelect}
                                    onChange={(value) => {
                                        dispatch(selectArrival(value?.firstInput?.step));
                                    }}
                                />
                                <ErrorContainer name="depositPlace" />
                            </FieldContainer>
                        </SlideInAnimation>
                    </div>
                </SlideInAnimation>

                <SlideInAnimation show={stage >= getFieldStage("depositPlace")}>
                    <Divider>Véhicule</Divider>
                    <div className="px-4 sm:flex sm:gap-16 sm:px-16">
                        <div className="sm:w-1/2">
                            <FieldContainer name="specification[registrationNumber]">
                                <Label htmlFor="bags">
                                    {t("booking.car_transport_registration_number")} :{" "}
                                </Label>
                                <Field
                                    id="registrationNumber"
                                    name="specification[registrationNumber]"
                                    placeholder="ex: LA-MALLE-43"
                                    component={Input}
                                />
                                <ErrorContainer name="specification[registrationNumber]" />
                            </FieldContainer>
                        </div>
                        <div className="mt-8 sm:mt-0 sm:w-1/2">
                            <FieldContainer name="specification[brand]">
                                <Label htmlFor="brand">
                                    {t("booking.car_transport_brand")} :{" "}
                                </Label>
                                <Field
                                    id="brand"
                                    name="specification[brand]"
                                    placeholder="ex: Renault"
                                    component={Input}
                                />
                                <ErrorContainer name="specification[brand]" />
                            </FieldContainer>
                        </div>
                    </div>
                    <div className="mt-8 px-4 sm:flex sm:gap-16 sm:px-16">
                        <div className="mt-8 sm:mt-0 sm:w-1/2">
                            <FieldContainer name="specification[model]">
                                <Label htmlFor="bags">
                                    {t("booking.car_transport_model")} :{" "}
                                </Label>
                                <Field
                                    id="model"
                                    name="specification[model]"
                                    placeholder="ex: Scénic"
                                    component={Input}
                                />
                                <ErrorContainer name="specification[model]" />
                            </FieldContainer>
                        </div>
                    </div>
                </SlideInAnimation>
            </>)}
        </WithStage>
    );
};

export default ItemFormFields;
